import { combineReducers } from "redux";
import login from "../containers/Auth/Login/reducer";
import signup from "../containers/Auth/SignUp/reducer";
import manage from "../containers/ManageSchedule/reducer";
import chat from "../containers/Chat/reducer";
import dashboard from "../containers/DashBoard/reducer";
import searchAllocatorReducer from "../containers/SearchAllocators/reducer";
import myFundsReducer from "../containers/MyFund/reducer";
import meetings from "../containers/Profile/MyMeetingsTab/reducer";
import fundDetail from "../containers/FundDetail/reducer";
import allocatorDetail from "../containers/AllocatorDetail/reducer";
import profile from "../containers/Profile/reducer";
import createNewUsers from "../containers/CreateNewUser/reducer";
import userDetails from "../containers/UpdateUser/reducer";
import getNewPosts from "../containers/NewsFeed/reducer";
import createNewPosts from "../containers/CreateNewPost/reducer";
import getMyPosts from "../containers/Profile/MyPosts/reducer";
import meetingDetails from "../containers/MeetingDetail/reducer";
import createFund from "../containers/CreateFund/reducer";
import createFCNQuery from "../containers/ContactFCNAdmin/reducer";
import createPerformanceMetrix from "../containers/PreviousPerformanceMatrix/reducer";
import documentDetail from "../containers/DocumentDetail/reducer";
import alertFactory from "../containers/App/ProtectedApp/reducer";
import forgetPassword from "../containers/Auth/ForgetPassword/reducer";
import resetPassword from "../containers/Auth/RestPassword/reducer";
import Impersonationlogin from "../containers/Auth/Impersonation/reducer";
import UserPreferencesStore from "../containers/UserPreference/reducer";
import CloudDocumentStore from "../containers/CloudDocument/reducer"
import StageAllocationStore from "../containers/StageAllocation/reducer"
import inMailData from "../containers/FCNinMails/reducer";
export default combineReducers({
  login,
  signup,
  manage,
  chat,
  searchAllocatorReducer,
  myFundsReducer,
  meetings,
  dashboard,
  fundDetail,
  allocatorDetail,
  profile,
  userDetails,
  createNewUsers,
  getNewPosts,
  createNewPosts,
  getMyPosts,
  meetingDetails,
  createFund,
  createFCNQuery,
  createPerformanceMetrix,
  documentDetail,
  alertFactory,
  forgetPassword,
  resetPassword,
  Impersonationlogin,
  UserPreferencesStore,
  CloudDocumentStore,
  StageAllocationStore,
  inMailData
});
